<template>
  <div id="base-input" class="form-input">
    <label :class="labelClassNames">{{ labelValue }}</label>
    <textarea
      ref="input"
      :type="type"
      :class="classNames"
      :placeholder="placeholder"
      v-model="content"
      @input="handleInput"
      :maxlength="maxLength"
    />
  </div>
</template>

<script>
export default {
  name: "BaseTextArea",
  props: {
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    classNames: {
      type: String,
      default: "form-control"
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    },
    labelValue: {
      type: String,
      default: ""
    },
    labelClassNames: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 500
    },
    needValidation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      content: this.value
    };
  },
  methods: {
    handleInput(e) {
      if(this.needValidation) {
        if (this.content === "" || this.content === " ") {
          this.$refs["input"].classList.add("error");
          return;
        }
      }
      
      this.$refs["input"].classList.remove("error");
      this.$emit("input", this.content);
    },
    clearContent() {
      this.content = "";
    }
  }
};
</script>

<style lang="scss">
#base-input {
  textarea {
    text-transform: none;
    resize: none;
  }
  textarea::-webkit-input-placeholder {
    text-transform: none;
  }
  textarea::-moz-placeholder {
    text-transform: none;
  }

  height: 100%;
  margin-bottom: 20px;
  .error {
    border: 2px solid #e44;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/inputs/BaseTextArea.vue